import { render, staticRenderFns } from "./LoadingSrcImage.vue?vue&type=template&id=72966880&scoped=true&"
import script from "./LoadingSrcImage.vue?vue&type=script&lang=js&"
export * from "./LoadingSrcImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72966880",
  null
  
)

export default component.exports